"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../index");

var _actions = require("../actions");

var _vehicle = require("../utils/vehicle");

var _reduxPersist = require("redux-persist");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {
  vehicles: null,
  currentBrand: null,
  //will be filled from getBrandTheme()
  currentId: null,
  currentYear: null,
  currentGroup: null,
  currentModel: null,
  currentProductType: null,
  currentProductSubtype: null,
  fetching: false,
  error: null
};

function vehicle(state, action) {
  var _getConfig = (0, _index.getConfig)(),
      COMING_SOON_CONTENT = _getConfig.COMING_SOON_CONTENT;

  state = state || _objectSpread({}, initialState, {
    currentBrand: (0, _vehicle.getBrandTheme)()
  });

  switch (action.type) {
    case _actions.GET_VEHICLES_REQUEST:
      return _objectSpread({}, state, {
        currentGroup: null,
        fetching: true,
        error: null
      });

    case _actions.GET_VEHICLES_SUCCESS:
      //TODO: remove hardcoded vehicles for Coming soon
      action.payload = [].concat(_toConsumableArray(action.payload.sort(function (a, b) {
        return a.model.localeCompare(b.model);
      })), _toConsumableArray(COMING_SOON_CONTENT));
      return _objectSpread({}, state, {
        vehicles: action.payload,
        fetching: false
      });

    case _actions.GET_VEHICLES_ERROR:
      return _objectSpread({}, state, {
        vehicles: null,
        fetching: false,
        error: action.payload
      });

    case _actions.SET_VEHICLE_GROUP:
      return _objectSpread({}, state, {
        currentGroup: action.payload
      });

    case _actions.SET_VEHICLE_MODEL:
      return _objectSpread({}, state, {
        currentModel: action.payload
      });

    case _actions.SET_VEHICLE_ID:
      return _objectSpread({}, state, {
        currentId: action.payload
      });

    case _actions.SET_VEHICLE_BRAND:
      return _objectSpread({}, state, {
        currentBrand: action.payload,
        currentId: null,
        currentModel: null,
        currentGroup: null,
        currentYear: null,
        currentProductType: null,
        currentProductSubtype: null
      });

    case _actions.SET_VEHICLE_YEAR:
      return _objectSpread({}, state, {
        currentYear: action.payload
      });

    case _actions.SET_VEHICLE_PRODUCT_TYPE:
      return _objectSpread({}, state, {
        currentProductType: action.payload
      });

    case _actions.SET_VEHICLE_PRODUCT_SUBTYPE:
      return _objectSpread({}, state, {
        currentProductSubtype: action.payload
      });

    case _actions.VEHICLES_RESET:
      return _objectSpread({}, state, {
        vehicles: null
      });

    case _reduxPersist.REHYDRATE:
      if (action.payload && action.payload.vehicle) return _objectSpread({}, state, action.payload.vehicle, {
        vehicles: null
      });
      return state;

    default:
      return state;
  }
}

var _default = vehicle;
exports.default = _default;